var map = {
	"./black/repository-black-da.json": 56,
	"./black/repository-black-de.json": 57,
	"./black/repository-black-ee.json": 58,
	"./black/repository-black-en.json": 59,
	"./black/repository-black-no.json": 60,
	"./black/repository-black-se.json": 61,
	"./grey/repository-grey-da.json": 62,
	"./grey/repository-grey-de.json": 63,
	"./grey/repository-grey-ee.json": 64,
	"./grey/repository-grey-en.json": 19,
	"./grey/repository-grey-no.json": 65,
	"./grey/repository-grey-se.json": 66,
	"./hd/repository-hd-da.json": 67,
	"./hd/repository-hd-de.json": 68,
	"./hd/repository-hd-ee.json": 69,
	"./hd/repository-hd-en.json": 70,
	"./hd/repository-hd-no.json": 71,
	"./hd/repository-hd-se.json": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;